/** PURE_IMPORTS_START .._operators_onErrorResumeNext PURE_IMPORTS_END */
import { onErrorResumeNextStatic } from '../operators/onErrorResumeNext';
export var onErrorResumeNext = onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/onErrorResumeNext.js
// module id = 778
// module chunks = 0